import { Button } from "@shared/primitive-components"
import { useClaimsFlow } from "./useClaimsFlow"

// --------------------------------------------------------------------------------------------------------------------

export const REPORT_AN_INCIDENT_SCREEN_DTI = {
  FLOCK_EFNOL_CLAIM_BUTTON: `flock_efnol_claim_button`,
  FMG_EFNOL_CLAIM_BUTTON: `fmg_efnol_claim_button`,
}

const LABEL = `Report an incident`

// --------------------------------------------------------------------------------------------------------------------

type ReportAnIncidentProps = Readonly<{
  /** Will hide the button if the viewer doesn't have the correct permission */
  hasPermission?: boolean
}>

// --------------------------------------------------------------------------------------------------------------------

// eslint-disable-next-line react/prop-types
export const ReportAnIncident: React.FC<ReportAnIncidentProps> = ({ hasPermission = false }) => {
  const claimsFlow = useClaimsFlow()

  // @TODO - we need to create our own claims permission
  if (hasPermission !== true || claimsFlow.type === `none`) return null

  if (claimsFlow.type === `internal`) {
    return (
      <Button
        variant="brand"
        onClick={() => window.open(`${window.origin}/create-claim-submission`, `_blank`)}
        data-testId={REPORT_AN_INCIDENT_SCREEN_DTI.FLOCK_EFNOL_CLAIM_BUTTON}
      >
        {LABEL}
      </Button>
    )
  }

  if (claimsFlow.type === `fmg`) {
    return (
      <Button
        variant="brand"
        onClick={() => window.open(claimsFlow.href, claimsFlow.target)}
        data-testid={REPORT_AN_INCIDENT_SCREEN_DTI.FMG_EFNOL_CLAIM_BUTTON}
      >
        {LABEL}
      </Button>
    )
  }

  throw new Error(`Invalid claims flow type`)
}
